/** First letter of the first two words, or the first two letters of a single word; punctuation never counts. */
export function getNetworkInitials(name: string): string {
  const words = name
    .split(/\s+/)
    .map(word => Array.from(word).filter(char => /[\p{L}\p{N}]/u.test(char)))
    .filter(letters => letters.length > 0);
  if (words.length === 0) return '';
  const letters = words.length === 1 ? words[0].slice(0, 2) : words.slice(0, 2).map(word => word[0]);
  return letters.join('').toLocaleUpperCase();
}
